import React from 'react';
import AnalizeClienti from './Analize';
import SpecificComponent from '../../commons/SpecificComponent';
import { Table, TableHead, TableRow, TableBody, TableCell } from '@material-ui/core';


export default class AnalizaDeVanzariSiClienti extends SpecificComponent{
    constructor(props) {
      super(props);
       this.state = {
        listEvs:null
}
    }

     componentDidMount(){
         this.nAnalize()
    }


    nAnalize = async () => {
                console.clear()
        let a = new AnalizeClienti()

        // let cP = await a.getClientiPierduti()        
        // console.log('clienti pierduti = ', cP)


        // let cC = await a.getClientiCastigati()  // acopera si clienti noi
        // console.log('clienti castigati = ', cC)


        // let fF = await a.getFacturi()
        // console.log('analiza facturi = ', fF)

        // let cLL = await a.clientiLoiali()
        // console.log('clienti loiali = ', cLL)
        

        // let cAc = await a.clientiActivi()
        // console.log('clienti activi = ', cAc)

        // let cSS = await a.analizaPeSemestru()
        // console.log('analiza semestriala = ', cSS)


        let evS = await a.evolutieSolduriClient()
        // console.log('analiza evolutie solduri client = ', evS)
        
        // let sEG = await a.segmentareClienti()
        // console.log('segmentare clienti = ', sEG)

      

        this.setState({listEvs:evS})
        
    }
     render() { 
       return (
          <div>
              {/* <h1 className='pm-title'>{this.dictionary.financiarContabil.analizaDeVanzariSiClienti}</h1> */}
                <h1 className='pm-title'>{this.dictionary.financiarContabil.evolutiaSolduluiPeClient}</h1>

                <div className='container'>
                    {this.state.listEvs &&
                      <Table style={{ width: '90%', margin: 'auto' }}>
                      <TableHead>
                          <TableRow style={{}}>

                              <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                                  {this.dictionary.financiarContabil.client}
                              </TableCell>
                              <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                                 {this.dictionary.financiarContabil.variatie}
                              </TableCell>
                              <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                              {this.dictionary.financiarContabil.evolutie}
                              </TableCell>
                            


                          </TableRow>
                      </TableHead>

                      <TableBody>
                          {this.state.listEvs.map((l, idx) => {
                              return (
                                  <TableRow  style={{ cursor: 'pointer' }} key={idx}>
                                      <TableCell style={{ textAlign: 'center' }}>
                                          {l.client}
                                      </TableCell>

                                      <TableCell style={{ textAlign: 'center' }} >
                                          {l.variatie}
                                      </TableCell>
                                      <TableCell style={{ textAlign: 'center' }} >
                                          {l.evolutie}
                                      </TableCell>
                                   

                                  </TableRow>
                              )
                          })}
                      </TableBody>
                  </Table>   
                }

                </div>

         </div>
        );
       }
}